import { createContext } from 'react';
import { buildAbility, type AppAbility } from '@/lib/ability';

export const AbilityContext = createContext<AppAbility>(buildAbility([], false));
